import { render, staticRenderFns } from "./ListModalAdd.vue?vue&type=template&id=8c65e1d2&scoped=true"
import script from "./ListModalAdd.vue?vue&type=script&lang=js"
export * from "./ListModalAdd.vue?vue&type=script&lang=js"
import style0 from "./ListModalAdd.vue?vue&type=style&index=0&id=8c65e1d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c65e1d2",
  null
  
)

export default component.exports